import { render, staticRenderFns } from "./ConfirmationTypeTooltip.vue?vue&type=template&id=172732d7&scoped=true&"
import script from "./ConfirmationTypeTooltip.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ConfirmationTypeTooltip.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ConfirmationTypeTooltip.vue?vue&type=style&index=0&id=172732d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172732d7",
  null
  
)

export default component.exports